/**
 * Ключи запросов — в одном месте.
 *
 * React Query связывает кэш и его сброс именно по ключу. Стоит написать
 * `['profile']` в запросе и `['profiles']` в сбросе — и после сохранения
 * форма показывает старые данные, а ошибки нет нигде: оба ключа
 * совершенно законны.
 */
export const queryKeys = {
  account: ['account'] as const,
  company: ['company'] as const,
  profile: ['profile'] as const,
  workingHours: ['working-hours'] as const,
  promptPreview: ['prompt-preview'] as const,
  voice: ['voice'] as const,
  calls: ['calls'] as const,
  call: ['call'] as const,
  outcomes: ['outcomes'] as const,
  stats: ['stats'] as const,
  agenda: ['agenda'] as const,
  setup: ['setup'] as const,
  setupChat: ['setup-chat'] as const,
  contacts: ['contacts'] as const,
  contact: ['contact'] as const,
  campaigns: ['campaigns'] as const,
  campaign: ['campaign'] as const,
  campaignTargets: ['campaign-targets'] as const,
  clientEvents: ['client-events'] as const,
  minutes: ['minutes'] as const,
  bots: ['bots'] as const,
  admin: {
    all: ['admin'] as const,
    stats: (period: string) => ['admin', 'stats', period] as const,
    balance: (days: number) => ['admin', 'balance', days] as const,
    companies: (query: string) => ['admin', 'companies', query] as const,
    company: (id: number | null) => ['admin', 'company', id] as const,
    calls: (scope: string, query: string) => ['admin', 'calls', scope, query] as const,
    call: (id: number | null) => ['admin', 'call', id] as const,
    audit: (query: string) => ['admin', 'audit', query] as const,
    minutes: (id: number) => ['admin', 'minutes', id] as const,
  },
}
